// export { default as AuthRouter } from "./AuthRouter";
// export { default as AppRouter } from "./AppRouter";
import React, { useEffect } from "react";

import AuthRouter from "./AuthRouter";
import AppRouter from "./AppRouter";

import { Layout } from "antd";
import Navigation from "@/layout/Navigation";

import { useSelector } from "react-redux";
import { selectAuth } from "@/redux/auth/selectors";

import UserLogin from "../components/UserView/Login/login";
import UserDashboard from "../components/UserView/Dashboard/dashboard";
import Howitworks from "../components/UserView/Howitworks/howitworks";
import Aboutus from "../components/UserView/Aboutus/aboutus";


export default function Router() {
  const { isLoggedIn } = useSelector(selectAuth);

  useEffect(() => {
    
  }, [isLoggedIn]);





 // get path /admin/*
 const path = window.location.pathname;
 // check path is /admin/*


  // if(isLoggedIn === true && window.location.pathname === "/admin")
  //   return (
  //     <Layout style={{ minHeight: "100vh" }}>
  //       <Navigation />
  //       <AppRouter />
  //     </Layout>
  //   );

  // else
  //   return (
  //     <Layout style={{ minHeight: "100vh" }}>
  //       <AuthRouter />
  //     </Layout>
  //   );
  
  //   }


 
if (isLoggedIn === true &&  window.location.pathname.includes("/admin"))
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Navigation />
      <Layout style={{ minHeight: "100vh" }}>
        <AppRouter />
      </Layout>
    </Layout>
  );


else {
return (
  <Layout style={{ minHeight: "100vh" }}>
    <AuthRouter />
  </Layout>
);
}
}
